export const REPO_URL = "github:duongductrong/cursor-kit";
export const REPO_REF = "master";
export const REPO_RAW_URL = "https://raw.githubusercontent.com/duongductrong/cursor-kit/master";

export const CURSOR_DIR = ".cursor";
export const COMMANDS_DIR = "commands";
export const RULES_DIR = "rules";
export const SKILLS_DIR = "skills";

export const COMMAND_EXTENSION = ".md";
export const RULE_EXTENSION = ".mdc";
export const SKILL_EXTENSION = ".mdc";

export const CONFIG_FILE = ".cursorkit";

export const TEMPLATE_PATHS = {
  commands: "templates/commands",
  rules: "templates/rules",
  skills: "templates/skills",
} as const;
